import { render } from "./AddEmoji.vue?vue&type=template&id=33a8c759&scoped=true"
import script from "./AddEmoji.vue?vue&type=script&lang=ts"
export * from "./AddEmoji.vue?vue&type=script&lang=ts"

import "./AddEmoji.vue?vue&type=style&index=0&id=33a8c759&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33a8c759"

export default script